module.exports = __webpack_public_path__ + "static/media/headerLogo.1e35a5a6.png";